import { render, staticRenderFns } from "./RSwitch.vue?vue&type=template&id=1514b7e6&"
import script from "./RSwitch.vue?vue&type=script&lang=js&"
export * from "./RSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports